import { makeUIHeading1, makeUIHeading2, makeUIHeading3, makeUIHeading4, makeUIHeading5, makeUIHeading6 } from '../../makeUIHeading';
const args = [{
  display: 'inline'
}, 'UIInlineHeading'];
export const UIInlineHeading1 = makeUIHeading1(...args);
export const UIInlineHeading2 = makeUIHeading2(...args);
export const UIInlineHeading3 = makeUIHeading3(...args);
export const UIInlineHeading4 = makeUIHeading4(...args);
export const UIInlineHeading5 = makeUIHeading5(...args);
export const UIInlineHeading6 = makeUIHeading6(...args);